import { authContext } from '@staffedupusa/shared-components';
import { Dispatch, SetStateAction, useContext } from 'react';
import { useQuery } from 'react-query';

import { notificationsKey } from '@features/notifications';
import { notificationsRoute } from '@features/enterpriseNotifications/api/constants';
import axiosInstance from '@server/axiosInstance';
import { notificationsCountKey } from '../constants';

export const useEnterpriseGetNotifications = ({ count }: { count?: boolean } = {}) => {

  const { authData } = useContext(authContext);
  const isEnabled = Boolean(authData?.isAuth && authData?.user && !authData?.user.is_admin && authData?.user.enterprise && !authData?.user.company);
  const { data: enterpriseNotificationsData, isFetched: isNotificationsFetched, isLoading: isNotificationsLoading } =
    useQuery({
      queryKey: [count ? notificationsCountKey : notificationsKey],
      queryFn: () =>
        axiosInstance.get(notificationsRoute + (count ? '?count=true' : '')).then((res) => res.data),
      enabled: isEnabled,
      refetchInterval: 300000,
      refetchOnWindowFocus: false,
    });
  return { enterpriseNotificationsData, isNotificationsFetched, isNotificationsLoading };
};